import React from 'react'

const serviceWay = (props) => {
    return(<div>test</div>);
}

export default serviceWay;